import React, { ReactNode } from "react";
import { Stack, Theme } from "sprint-common-web";

interface PublicDefaultLayoutProps {
    children: ReactNode;
}

export const PublicDefaultLayout: React.FC<PublicDefaultLayoutProps> = ({ children }: PublicDefaultLayoutProps) => {
    return (
        <>
            <Stack styles={{ root: { backgroundColor: Theme.palette.themePrimary, height: 41 } }} />
            <Stack horizontalAlign="center" styles={{ root: { height: "70vh", justifyContent: "center" } }}>
                {children}
            </Stack>
        </>
    );
};
